window.fbAsyncInit = () => {
  FB.init({
    appId:   '784910018308721',
    xfbml:   true,
    version: 'v2.5'
  });
};

let addFbScript = function() {
  let firstScriptElement = document.getElementsByTagName("script")[0];
  if (document.getElementById("facebook-jssdk")) { return; }
  let scriptElement = document.createElement("script");
  scriptElement.id = "facebook-jssdk";
  scriptElement.src = "//connect.facebook.net/pl_PL/sdk.js";
  firstScriptElement.parentNode.insertBefore(scriptElement, firstScriptElement);
  return scriptElement;
};

$(document).ready(() => addFbScript());



// WEBPACK FOOTER //
// ./app/webpack/frontend/config/facebook_sdk.js